// @flow

import crypto from 'crypto';
import {
  unescape as base64Unescape
} from 'base64-url';
import {
  InvalidGuideError,
  UnexpectedNamespaceValueError,
  UnexpectedResourceTypeNameValueError
} from './errors';
import type {
  FromGuideType
} from './types';

/**
 * @throws InvalidGuideError Throws if input guide cannot be decrypted.
 * @throws UnexpectedNamespaceValueError Throws if the namespace contained in the payload does not match the expected namespace.
 * @throws UnexpectedResourceTypeNameValueError Throws if the resource type name contained in the payload does not match the expected resource type name.
 */
const fromGuide: FromGuideType = (initializationVectorValue, expectedNamespace, expectedResourceTypeName, guide) => {
  const decodedGuide = new Buffer(base64Unescape(guide), 'base64');

  const tag = decodedGuide.slice(0, 16);
  const body: Buffer = decodedGuide.slice(16);

  const decipher = crypto.createDecipher('aes-256-gcm', initializationVectorValue);

  decipher.setAuthTag(tag);

  let payload;

  try {
    const decryptedGuide = decipher.update(body).toString() + decipher.final().toString();

    payload = JSON.parse(decryptedGuide);
  } catch (error) {
    // console.log('error', error);
    throw new InvalidGuideError(guide);
  }

  if (expectedNamespace !== payload.namespace) {
    throw new UnexpectedNamespaceValueError(guide, expectedNamespace, expectedResourceTypeName, payload);
  }

  if (expectedResourceTypeName !== payload.type) {
    throw new UnexpectedResourceTypeNameValueError(guide, expectedNamespace, expectedResourceTypeName, payload);
  }

  return {
    id: payload.id,
    namespace: payload.namespace,
    type: payload.type
  };
};

export default fromGuide;
